import { DarkIcon } from "../../shared/Icons/DarkIcon";
import { LightIcon } from "../../shared/Icons/LightIcon";
import Typography from "../../shared/typography/Typography";
import { Container } from "./style";

export type ThemeType = 'light' | 'dark';

interface IProps {
  themeType: ThemeType;
  onClick: () => void;
  colapsed?: boolean;
}

export const ThemeButton = ({themeType, onClick, colapsed=false}: IProps) => {
  return (
    <Container onClick={onClick} themeType={themeType} colapsed={colapsed}>
      {themeType === 'light' ? (
        <>
          {!colapsed && <Typography type="headingXXXS" color="placeholder" >Light Mode</Typography>}
          <LightIcon size={colapsed ? 21 : 24} />
        </>
      ) : (
        <>
          {!colapsed && <Typography type="headingXXXS" color="white" >Dark Mode</Typography>}
          <DarkIcon size={colapsed ? 21 : 24} />
        </>
      )}
    </Container>
  );
}